import axios from 'axios'

/** Response envelope from the BE for enqueue endpoints. */
type EnqueueResponse = { success: boolean; data: { job_id: string } }

async function enqueue(url: string): Promise<{ job_id: string }> {
    const res = await axios.post<EnqueueResponse>(url, null, {
        withCredentials: true,
    })
    return res.data.data
}

async function fetchHtml(url: string): Promise<string> {
    const res = await axios.get<string>(url, {
        withCredentials: true,
        responseType: 'text',
    })
    return res.data
}

/** Print-label API.
 *  - `enqueue*`: đẩy job vào durable queue → Windows agent tại kho lấy PDF,
 *    in ra Canon LBP223dw, ack. Dùng cho tablet/mobile.
 *  - `getHtml*`: trả HTML A7 tự-print (`window.print` onload) — dùng cho
 *    desktop qua iframe `printReceiptHtml`. 1 call = 1 tem. */
export const printLabelApi = {
    enqueueSortingLot: (id: string) =>
        enqueue(`/api/v1/sorting-lots/${id}/print-label`),
    enqueueScentingLot: (id: string) =>
        enqueue(`/api/v1/scenting-lots/${id}/print-label`),
    enqueuePackagingLot: (id: string) =>
        enqueue(`/api/v1/packaging-lots/${id}/print-label`),
    enqueueProductLot: (id: string) =>
        enqueue(`/api/v1/product-lots/${id}/print-label`),

    getHtmlSortingLot: (id: string) =>
        fetchHtml(`/api/v1/sorting-lots/${id}/print-label/html`),
    getHtmlScentingLot: (id: string) =>
        fetchHtml(`/api/v1/scenting-lots/${id}/print-label/html`),
    getHtmlPackagingLot: (id: string) =>
        fetchHtml(`/api/v1/packaging-lots/${id}/print-label/html`),
    getHtmlProductLot: (id: string) =>
        fetchHtml(`/api/v1/product-lots/${id}/print-label/html`),
    /** M-134: tem lô của các dòng sản phẩm trên sổ 12,5g trong MỘT tài liệu,
     *  mỗi tem một trang — "In tất cả" chỉ mở một hộp thoại in. */
    getHtmlPackagingLogOutputs: (outputIds: readonly string[]) =>
        fetchHtml(
            `/api/v1/product-lots/packaging-log-entries/outputs/print-labels/html?ids=${outputIds.map(encodeURIComponent).join(',')}`,
        ),
}
